<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <h1 id="title" class="page-title">{{ pageTitle }}</h1>
        <p class="nd-page-kicker">Configure a especialidade para agenda, profissionais e filtros de atendimento.</p>
      </div>
    </header>

    <v-card class="nd-section-card">
      <v-form ref="specialtyForm" v-model="formValid">
        <div class="nd-table-toolbar">
          <div>
            <div class="nd-table-toolbar__title">Dados da especialidade</div>
            <div class="nd-table-toolbar__subtitle">Informações principais do cadastro.</div>
          </div>
        </div>
        <div class="nd-form-grid">
          <v-text-field
            id="name"
            label="Nome"
            v-model="specialty.name"
            :rules="[rules.required]"
            outlined
            dense
           hide-details="auto"></v-text-field>
        </div>
        <div class="nd-form-actions">
          <v-btn id="btnCancel" type="button" color="primary" outlined elevation="0" @click="$router.push('/especialidades')">
            Voltar
          </v-btn>
          <v-btn id="btnSave" type="button" color="primary" elevation="0" @click="saveSpecialty" :loading="loadingSave">
            Salvar
          </v-btn>
        </div>
      </v-form>
    </v-card>

    <v-overlay :value="loadingPage">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SpecialtiesDetails",

  data: () => ({
    specialty: {
      id: null,
      name: "",
    },

    loadingPage: false,
    loadingSave: false,
    formValid: false,

    rules: {
      required: (value) => !!value || "Campo obrigatório.",
    },
  }),

  computed: {
    pageTitle() {
      return this.specialty.id ? "Detalhes da Especialidade" : "Nova Especialidade";
    },
    breadcrumbs() {
      const currentItemText = this.specialty.id ? "Detalhes da Especialidade" : "Nova Especialidade";
      return [
        { text: "Home", disabled: false, to: "/home", exact: true },
        { text: "Especialidades", disabled: false, to: "/especialidades", exact: true },
        { text: currentItemText, disabled: true, exact: true },
      ];
    },
  },

  async created() {
    this.loadingPage = true;
    const specialtyId = this.$route.params.id;

    if (specialtyId) {
      await this.loadSpecialty(specialtyId);
    }
    this.loadingPage = false;
  },

  methods: {
    async loadSpecialty(id) {
      try {
        const response = await axios.get(`/specialties/${id}`);
        const data = response.data.data;
        this.specialty = {
          id: data.id,
          name: data.name,
        };
      } catch (error) {
        this.$dialog.notify.error("Erro ao carregar detalhes da especialidade.", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },

    async saveSpecialty() {
      if (this.$refs.specialtyForm.validate()) {
        this.loadingSave = true;
        try {
          const payload = { name: this.specialty.name };

          if (this.specialty.id) {
            await axios.patch(`/specialties/${this.specialty.id}`, payload);
            this.$dialog.notify.success("Especialidade atualizada com sucesso!", {
              position: "top-right",
              timeout: 3000,
            });
          } else {
            await axios.post("/specialties", payload);
            this.$dialog.notify.success("Especialidade criada com sucesso!", {
              position: "top-right",
              timeout: 3000,
            });
          }
          this.$router.push("/especialidades");
        } catch (error) {
          const code = error?.response?.data?.data?.code;
          const message = code === 1317
            ? "Já existe uma especialidade com esse nome."
            : "Erro ao salvar especialidade. Verifique os dados.";
          this.$dialog.notify.error(message, {
            position: "top-right",
            timeout: 5000,
          });
        } finally {
          this.loadingSave = false;
        }
      }
    },
  },
};
</script>
